<template>
  <div class="wrap">
    <g-header :navActive="2"></g-header>
    <div class="content">
      <div class="block" v-for="(item, index) in data" :key="index">
        <div class="content-wrap g-clear-float">
          <div class="text-wrap">
            <p>{{item.text1}}</p>
            <p>{{item.text2}}</p>
            <p>
              <span>内&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;容：</span>
              <span>{{item.text3}}</span>
            </p>
            <p>
              <span>联系方式：</span>
              <span>{{item.text4}}</span>
            </p>
            <p v-show="index===2">
              <span>传&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;真：</span>
              <span>025-84436525</span>
            </p>
            <p>
              <span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</span>
              <span>{{item.text5}}</span>
            </p>
            <p v-show="index===2" >
              <span style="display:inline-block;width:92px;text-align:right">QQ：</span>
              <span>813881360</span>
            </p>
          </div>
          <div class="img-wrap">
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>
    <g-footer></g-footer>
  </div>
</template>
<script>
export default {
  name: "cooperation",
  data() {
    return {
      data: [
        {
          img: require("./imgs/1.png"),
          text1: "医保管理与经办单位",
          text2: "包括各级医疗保障局、医保中心",
          text3:
            "利用人工智能、区块链、生物识别、大数据、安全管理等科技手段，为医保部门提供药械数据标准化服务、交易真实性鉴证、基金风险性分析等智能化解决方案。",
          text4: "010-88050623",
          text5: 'xhyb@news.cn'
        },
        {
          img: require("./imgs/2.png"),
          text1: "各类医保信息系统建设与服务商",
          text2: "包括各类医保信息化系统承建商、各类医疗与药事信息化服务商",
          text3:
            "业务场景交流，探讨药械鉴核服务与各业场景与信息系统的结合模式和数据对接标准。",
          text4: "010-64939107",
          text5: 'xhyb@news.cn'
        },
        {
          img: require("./imgs/3.png"),
          text1: "药品器械追溯服务对接",
          text2: "包括药品器械制造厂商、提供药品和器械第三方追溯服务厂商",
          text3:
            "依照数据标准，对接药品器械追溯信息到药械鉴核平台，利于医保支付，避免市场风险。",
          text4: "025-83650181",
          text5: 'xhyb.kf@xinhuanet.com'
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("app").scrollTop = 0;
    });
  }
};
</script>
<style lang="stylus" scoped>
.wrap {
  margin-top: 60px;

  .content {
    .block {
      min-height: 400px;
      padding: 60px 0 50px;
      box-sizing: border-box;

      &:nth-child(odd) {
        background-image: linear-gradient(
          90deg,
          #0d0d32 0%,
          #143573 50%,
          #0d0d32 100%
        ), linear-gradient(
          #230808,
          #230808
        );
        -ms-filter: "progid:DXImageTransform.Microsoft.Gradient(startColorStr='#0d0d32',endColorStr='#143573',gradientType='0')";
      }

      &:nth-child(even) {
        background-color: #ffffff;

        .content-wrap {
          .text-wrap {
            float: right;
            p {
              color: #333333;
              &:nth-child(1) {
                color: #14316c;
              }
              &:nth-child(2) {
                color: #3f70cf;
              }
            }
          }

          .img-wrap {
            float: left;

            img {
              box-shadow: 25px 25px 0 0px #5371e2;
            }
          }
        }
      }

      .content-wrap {
        width: 1200px;
        margin: 0 auto;

        .text-wrap {
          float: left;
          width: 700px;

          p {
            margin-top: 15px;
            font-size: 18px;
            color: #ffffff;

            &:nth-child(3), &:nth-child(4),&:nth-child(5), &:nth-child(6), &:nth-child(7) {
              padding-left: 100px;
              position: relative;
            }

            span {
              &:nth-child(1) {
                white-space: pre-wrap;
                position: absolute;
                left: 0;
                top: 0;
              }
            }

            &:nth-child(1) {
              font-size: 30px;
              color: #fefefe;
              margin-top: 0;
            }

            &:nth-child(2) {
              font-size: 24px;
              color: #ffea00;
            }

            &:nth-child(1), &:nth-child(2) {
              text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
              font-weight: bold;
            }
          }
        }

        .img-wrap {
          float: right;
          width: 396px;

          img {
            width: 360px;
            border-radius: 10px;
            box-shadow: 25px 25px 0 0px #459ce6;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/cooperation/index.vue